<template>
  <div id="app">
    <b-container class="bv-example-row">
        <img class="logo" src="./assets/logo-dw.png">
        <hr>
        <b-row>
            <b-col>
              <b-card title="Trello"
                      tag="article"
                      class="mb-2">
                <p class="card-text">Trello is a web-based project management application, we use it for our Projects</p>
                <b-button target="_blank" href="https://trello.com/digitalwunder" variant="primary">Link</b-button>
              </b-card>
            </b-col>
            <b-col>
              <b-card title="Mocoapp"
                      tag="article"
                      class="mb-2">
                <p class="card-text">Invoices, Timemanagement, you can do it all related to bookkeeping.</p>
                <b-button target="_blank" href="https://digitalwunder.mocoapp.com" variant="primary">Link</b-button>
              </b-card>
            </b-col>
            <b-col>Coming more ...</b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Admin Panel'
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.logo {
  width: 400px;
  margin-bottom: 10px;
}

.btn {
  background-color: #03a9f3;
  border-color: #03a9f3;
  padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue